module.exports = __webpack_public_path__ + "img/gait_phase.7fe1302e.png";